import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './lib/auth';
import { queryClient } from './lib/queryClient';
import { App } from './App';
import { BrandingSync } from './lib/branding';
import { ServiceWorkerNavigate, registerServiceWorker } from './lib/push';
import './index.css';

// t232u: Web Push service worker (no fetch handler: caching and offline behaviour are unchanged).
if (import.meta.env.PROD) void registerServiceWorker();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrandingSync />
        <BrowserRouter>
          <ServiceWorkerNavigate />
          <App />
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
